import * as React from "react";

const SvgChevronUp = props => <svg stroke="currentColor" fill="none" strokeWidth={2} viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round" xmlns="http://www.w3.org/2000/svg" {...props}><polyline points="18 15 12 9 6 15" /></svg>;

export default SvgChevronUp;